import { Box, FormControl, FormLabel, Grid, Paper, RadioGroup, Stack, Typography } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import { RadioForm } from "~/src/components/molecules"
import { TUserProfile } from "~/src/repositories/User/models/User"
import { SummaryPriceTypography, SummaryTotalTypography, TitleTypography } from "./QuotationDetail.styles"
import { formatNumber } from "~/src/libs"
import { formatPrice } from "~/src/utils/formatPrice"

interface IQuotationDetailSummaryProps {
  data?: IQuotationDetailItem[]
  loadingPortId: number 
}

interface IQuotationDetailItem {
  id: number
  refNo: string
  displayName: string
  category: string
  withCatalyst?: string
  price: number
  isPurchased: boolean
  isSold: boolean
  loadingPorts: [{
    id: number
    transportationFee: number
  }],
}

export const QuotationDetailSummary: React.FC<IQuotationDetailSummaryProps> = ({
  data,
  loadingPortId
}): JSX.Element => {
  const { t } = useTranslation()

  let totalPrice = 0
  let activeCount = 0
  let purchasedCount = 0
  let soldCount = 0
  let notAvailableCount = 0
  data?.map((item) => {
    if (item.loadingPorts.some(loadingPort => loadingPort.id === loadingPortId)) {
      totalPrice += item.price + item.loadingPorts.find((loadingPort) => loadingPort.id === loadingPortId)?.transportationFee
      if (item.isPurchased) {
        purchasedCount++
        return
      }
      if (item.isSold) {
        soldCount++
        return
      }
      activeCount++
    } else {
      notAvailableCount++
    }
  })

  return (
    <Paper>
      <Grid container>
        <Grid item lg={6}>
      <TitleTypography>
        {t('quotation_detail.quotation_summary')}
      </TitleTypography>
        </Grid>
        <Grid item lg={6} textAlign={'right'}>
      <SummaryTotalTypography>
          {formatPrice('STOCK', totalPrice)}
      </SummaryTotalTypography>
        </Grid>
      </Grid>
      <Grid container px={3} py={1}>
        <Grid item lg={8}>
          <SummaryPriceTypography>
            {t('quotation_detail.order_total')}
          </SummaryPriceTypography>
        </Grid>
        <Grid item lg={4}>
          <SummaryPriceTypography>
            {formatNumber(data?.length)}
          </SummaryPriceTypography>
        </Grid>
        <Grid item lg={8}>
            <Typography
              fontSize={'14px'}
              align="right"
            >
              {t('quotation_detail.active')}
            </Typography>
        </Grid>
        <Grid item lg={4}>
          <SummaryPriceTypography>
            {formatNumber(activeCount)}
          </SummaryPriceTypography>
        </Grid>
        <Grid item lg={8}>
            <Typography
              fontSize={'14px'}
              align="right"
            >
              {t('quotation_detail.purchased')}
            </Typography>
        </Grid>
        <Grid item lg={4}>
          <SummaryPriceTypography>
            {formatNumber(purchasedCount)}
          </SummaryPriceTypography>
        </Grid>
        <Grid item lg={8}>
            <Typography
              fontSize={'14px'}
              align="right"
            >
              {t('quotation_detail.sold')}
            </Typography>
        </Grid>
        <Grid item lg={4}>
          <SummaryPriceTypography>
            {formatNumber(soldCount)}
          </SummaryPriceTypography>
        </Grid>
        <Grid item lg={8}>
            <Typography
              fontSize={'14px'}
              align="right"
            >
              {t('quotation_detail.not_available')}
            </Typography>
        </Grid>
        <Grid item lg={4}>
          <SummaryPriceTypography>
            {formatNumber(notAvailableCount)}
          </SummaryPriceTypography>
        </Grid>
      </Grid>
    </Paper>
  )
}